import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import iconClipboard from "../../img/icons/icon-clipboard.svg";
import * as Utils from "../../inc/Utils";

export default function ResearcherSidebar(prop) {
    let navigate = useNavigate();

    React.useEffect(() => {
        let memberTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(memberTokens) {
            let memberJson = JSON.parse(memberTokens);
            let checkExpireHrs = (Math.abs(new Date().getTime() - new Date(memberJson.latestLoginAt).getTime()) / 3600000);
            if(checkExpireHrs > Utils.HOURS_EXPIRE_LOGIN) {
                navigate((prop.lang === 'en' ? '/en':'/') + 'login');
            }
        }
        else {
            window.location.href = (prop.lang === 'en' ? '/en':'/') + 'login';
        }
    }, []);

    return (
        <>
            <ul className="nav nav-sidebar" data-aos="fade-in">
                <li className={prop.active === 'info' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher':'/profile/researcher'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Researcher Info':'ข้อมูลนักวิจัย'}</NavLink>
                </li>
                <li className={prop.active === 'education' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/education':'/profile/researcher/education'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Education':'ประวัติการศึกษา'}</NavLink>
                </li>
                <li className={prop.active === 'work' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/work':'/profile/researcher/work'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Work History':'ประวัติการทำงาน'}</NavLink>
                </li>
                <li className={prop.active === 'training' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/training':'/profile/researcher/training'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Training History':'ประวัติการฝึกอบรม'}</NavLink>
                </li>
                <li className={prop.active === 'certificate' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/certificate':'/profile/researcher/certificate'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Certificate':'ใบรับรองและประกาศนียบัตร'}</NavLink>
                </li>
                <li className={prop.active === 'intellectual' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/intellectual':'/profile/researcher/intellectual'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Intellectual':'ทรัพย์สินทางปัญญา'}</NavLink>
                </li>
                <li className={prop.active === 'award' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/award':'/profile/researcher/award'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Awards':'รางวัลที่ได้รับ'}</NavLink>
                </li>
                <li className={prop.active === 'ongoing' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/ongoing':'/profile/researcher/ongoing'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Ongoing Research':'งานวิจัยที่กำลังดำเนินการ'}</NavLink>
                </li>
                <li className={prop.active === 'completed' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile/researcher/completed':'/profile/researcher/completed'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Completed Research':'งานวิจัยที่ดำเนินการเสร็จแล้ว'}</NavLink>
                </li>
            </ul>

            <p className="text-center mt-4">
                <NavLink to={prop.lang === 'en' ? '/en/profile':'/profile'} className="btn btn-xs btn-gray w-50 m-auto">
                    {prop.lang === 'en' ? 'Back':'กลับหน้าหลัก'}
                </NavLink>
            </p>
        </>
    );
} 